import { defer } from "react-router-dom";

import { transactionsLocationsQuery } from "@/services/lukita/queries";

import { TRANSACTION_PAYMENT_CHANNELS } from "../../constants";
import getAccount from "../helpers/get-account";
import getQueryParams from "../helpers/get-query-params";
import getTransactions from "../helpers/get-transactions";

export default function locationsLoader({ request, params }) {
  const { first, skip } = getQueryParams(request.url);

  const transactions = getTransactions({
    slug: params.projectSlug,
    first,
    skip,
    channel: TRANSACTION_PAYMENT_CHANNELS.inStore,
  });

  const locations = getAccount().then((account) =>
    transactionsLocationsQuery({
      slug: params.projectSlug,
      accountId: account?.id,
      channel: TRANSACTION_PAYMENT_CHANNELS.inStore,
    }).then(({ project }) => project.locations),
  );

  return defer({
    transactions,
    locations,
  });
}
